import { createSlice } from '@reduxjs/toolkit';

import { BrandsState } from '../../types';

import { BRANDS_STATE } from '../../constants';

import { setFavouriteBrands } from './setFavouriteBrands';
import { addFavouriteStations } from './addFavouriteBrands';
import { deleteFavouriteBrands } from './deleteFavouriteBrands';
import { resetDeletingStatus } from './resetDeletingStatus';
import { setAddingFavouriteBrandsStatus } from './setAddingFavouriteBrandsStatus';

const initialState: BrandsState = {
  favouriteBrands: {}
};

export const brandsSlice = createSlice({
  name: BRANDS_STATE,
  initialState,
  reducers: {
    resetDeletingStatus,
    setAddingFavouriteBrandsStatus
  },
  extraReducers: (builder) => {
    setFavouriteBrands(builder);
    addFavouriteStations(builder);
    deleteFavouriteBrands(builder);
  }
});

export const brandsActions = brandsSlice.actions;
export const brandsReducer = brandsSlice.reducer;
